import React, { useState } from 'react';
import PropTypes from 'prop-types';

/**
 * Code block for the integration guide — dark panel with optional label and copy.
 * Pass `text` for plain copy, or `children` for syntax-highlighted markup inside pre.
 */
const DocsCodeBlock = ({ text, children, label }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    const value = text ?? (typeof children === 'string' ? children : '');
    if (!value && children) {
      return;
    }
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      /* clipboard unavailable */
    }
  };

  const copySource =
    text ??
    (typeof children === 'string' ? children : null);

  const copyButton = copySource ? (
    <button
      type="button"
      className={`copy-btn${copied ? ' copied' : ''}`}
      onClick={handleCopy}
    >
      {copied ? 'Copied' : 'Copy'}
    </button>
  ) : null;

  return (
    <div className={`code-block${label ? ' has-label' : ''}`}>
      {label ? (
        <div className="code-block-header">
          <span className="code-block-label">{label}</span>
          {copyButton}
        </div>
      ) : (
        copyButton
      )}
      <pre>{children ?? text}</pre>
    </div>
  );
};

DocsCodeBlock.propTypes = {
  text: PropTypes.string,
  children: PropTypes.node,
  label: PropTypes.string,
};

export default DocsCodeBlock;
